/**
 * Тема: темная/светлая/системная. Базовая — темная (решение D-18, токены 2.0.0):
 * без явного выбора приложение всегда темное, светлая включается в настройках.
 * Механика из tokens.css: темная живет в :root, светлая включается
 * [data-theme="light"] или системной настройкой при выборе «system».
 */

export type ThemeChoice = 'dark' | 'light' | 'system';

const STORAGE_KEY = 'luum-theme';

export function applyTheme(choice: ThemeChoice): void {
  const root = document.documentElement;
  if (choice === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', choice);
}

export function loadThemeChoice(): ThemeChoice {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === 'dark' || raw === 'light' || raw === 'system') return raw;
  } catch {
    // приватный режим и т.п. — молча падаем на базовую темную
  }
  return 'dark';
}

export function saveThemeChoice(choice: ThemeChoice): void {
  try {
    localStorage.setItem(STORAGE_KEY, choice);
  } catch {
    // некритично
  }
  applyTheme(choice);
}

/** Вызывается один раз при старте приложения. */
export function initTheme(): void {
  applyTheme(loadThemeChoice());
}
